import { TransportErrors } from '../enums/errors';
/**
 * An error that was thrown during the process of making a request.
 */
export class RequestError extends Error {
    constructor(message, code, status, url) {
        super(message);
        this.name = 'RequestError';
        this.message = message;
        this.code = code;
        this.status = status || 0;
        this.url = url;
    }
}
export class RequestAbortedError extends RequestError {
    constructor(url, reason) {
        super('Request aborted by signal.', TransportErrors.HTTP_REQUEST_ABORTED, 0, url);
        this.name = 'RequestAbortedError';
        this.reason = reason;
    }
}
export class RequestTimeoutError extends RequestError {
    constructor(url, reason) {
        super('Request aborted by timeout.', TransportErrors.HTTP_REQUEST_TIMEOUT, 0, url);
        this.name = 'RequestTimeoutError';
        this.reason = reason;
    }
}
//# sourceMappingURL=request.js.map